<template>
  <div id="gl_charge_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <span class="page-title" id="glChargeHeader" v-if="$route.params.id > 0">Update GL Charge</span>
          <span class="page-title" id="glChargeHeader" v-else>Add GL Charge</span>
          <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackGLChargeList">
            <i class="fp-back"> </i> Back
          </button>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content">
            <section class="internal-container border-top-table-fl">
              <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="glChargeForm">
                <div class="form-row row-cols-md-3 row-cols-1">

                  <div class="col form-group">
                    <label class="control-label require" for="charge_identifier">Charge Identifier:</label>
                    <v-select v-model="charge_identifier_id" name="charge_identifier"
                              placeholder="Select Charge Identifier Type."
                              label="text"
                              :options="contractChargesArr" id="charge_identifier" @input="onChargeIdentifier($event)">
                    </v-select>
                    <div class="field-error">{{ charge_identifier_err_msg }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require" for="charge_type">Charge Type:</label>
                    <v-select v-model="charge_type" name="charge_type" placeholder="Select Charge Type."
                              label="text"
                              :options="chargeTypesArr" id="charge_type" @input="onChargeTypeSelect($event)">
                    </v-select>
                    <div class="field-error">{{ charge_type_error_msg }}</div>
                  </div>


                  <div class="col form-group">
                    <label class="control-label require" for="location_id">Location:</label>
                    <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                              label="text"
                              :options="locationArr" id="location_id" @input="onLocationSelect($event)">
                    </v-select>
                    <div class="field-error">{{ location_error_msg }}</div>
                  </div>

                </div>

                <div class="form-row row-cols-md-3 row-cols-1">
                  <div class="col form-group">
                    <label class="control-label require" for="contract_type">Contract Type:</label>
                    <v-select v-model="contract_type_id" name="contract_type" placeholder="Select Charge Type."
                              label="text"
                              :options="contractTypeArr" id="contract_type" @input="onChangeContractType($event)">
                    </v-select>
                    <div class="field-error">{{ contract_type_error_msg }}</div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label require" for="vehicle_pool">Vehicle Pool:</label>
                    <v-select v-model="vehicle_pool_id" name="vehicle_pool"
                              placeholder="Select Vehicle Pool."
                              label="text"
                              :options="assetPoolArr" id="vehicle_pool" @input="onChangeVehiclePool($event)">
                    </v-select>
                    <div class="field-error">{{ vehicle_pool_err_msg }}</div>
                  </div>


                  <div class="col form-group">
                    <label class="control-label require" for="gl_account">GL Account:</label>
                    <!--<v-select v-model="gl_account_id" name="gl_account" placeholder="Select GL Account."
                              label="text"
                              :options="glAccountArr" id="gl_account" @input="onGLAccountSelect($event)">
                    </v-select>-->
                    <v-select v-model="gl_account_id" name="gl_account" id="gl_account" @input="onGLAccountSelect($event)" label="text" :filterable="false" :options="accountsArr" @search="onSearchAccount" placeholder="GL Account" class='custom-ci-auto-search contract-data'>
                        <template slot="no-options">
                            Search GL Account...
                        </template>
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.text }}
                            </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            <div class="selected d-center">
                                {{ option.text }}
                            </div>
                        </template>
                    </v-select>
                    <div class="field-error">{{ gl_account_error_msg }}</div>
                  </div>

                  <div class="field-error">{{ common_error_msg }}</div>
                </div>


                <div class="form-group">
                  <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
                      aria-hidden="true">&times;</span></button>
                    <strong id="errorMsg" class="field-error"></strong>
                  </div>
                </div>
                <div class="btn-groups">
                  <button type="submit" id="CreateGLChargeBtn" v-if="$route.params.id > 0" class="btn btn-primary"
                          v-on:click.prevent="CreateGLCharge">
                    <i class="fp-reload"> </i> Update
                  </button>
                  <button type="submit" id="CreateGLChargeBtn" v-else class="btn btn-primary"
                          v-on:click.prevent="CreateGLCharge">
                    <i class="fp-save"> </i> Save
                  </button>
                  <button type="submit" id="createAndContinueGLChargeBtn" v-if="$route.params.id == undefined"
                          class="btn btn-tertiary" v-on:click.prevent="CreateGLCharge(flag='Save and Continue')">
                    <i class="fp-save-continue"> </i> Save and Continue
                  </button>
                  <button type="submit" id="cancelGLAccountBtn" class="btn btn-tertiary"
                          v-on:click.prevent="BackGLChargeList">
                    <i class="fp-close"> </i> Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';
export default {
  name: "GLChargeCreate",
  metaInfo() {
    return {
      title: (this.$route.params.id > 0) ? "Update GL Charge | " +process.env.COPYRIGHT_NAME : "Create GL Charge | " +process.env.COPYRIGHT_NAME
    }
  },
  mixins: [commonMixins, contractMixins],
  data: () => ({
    loading: false,
    cantAccessPage: "",
    locationPartDisable: false,

    permissions: [],
    contractTypeArr: [],
    glAccountArr: [],
    locationArr: [],
    contractChargesArr: [],
    assetPoolArr: [],
    accountsArr:[],

    location_id: "",
    charge_type: "",
    contract_type_id: "",
    gl_account_id: "",
    charge_identifier_id: "",
    vehicle_pool_id: "",

    location_error_msg: "",
    charge_type_error_msg: "",
    contract_type_error_msg: "",
    gl_account_error_msg: "",
    charge_identifier_err_msg: "",
    vehicle_pool_err_msg: "",
    common_error_msg: "",
  }),
  watch: {

    // check permission change
    permissions: function (permissions) {
      var self = this;

      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'add_gl_account') {
            self.cantAccessPage = true;
          }
        }
      }
    }
  },
  created: function () {

  },
  mounted: function () {
    var self = this;
    self.getPermissions();
    self.loadFieldData(['accountTypes', 'location', 'contractType', 'gl_account', 'contract_misc_charges', 'vehicle_pool']);

    setTimeout(function () {
      var path = window.location.pathname;
      var segments = path.split("/");

      if (segments[3]) {
        self.loadGLAccount();
      }
    }, 100);
  },
  methods: {
    BackGLChargeList() {
      var self = this;
      self.$router.push("/charge-account/list");
    },

    onLocationSelect() {
      var self = this;
      self.location_error_msg = "";
      if (self.location_id != null) {
        self.glCodeField1 = self.location_id.location_code;
        self.locationPartDisable = true;
      } else {
        self.locationPartDisable = true;
        self.glCodeField1 = "";
      }
    },

    onChargeTypeSelect() {
      var self = this;
      self.charge_type_error_msg = "";
    },

    onChangeContractType() {
      var self = this;
      self.contract_type_error_msg = "";
    },

    onSearchAccount(search, loading) {
      var self = this;
      if (search.length > 5) {

          loading(true);
          self.searchField(loading, search, 'accounts', '');
      }
    },

    onGLAccountSelect() {
      var self = this;
      self.gl_account_error_msg = "";
    },

    onChargeIdentifier() {
      var self = this;
      self.charge_identifier_err_msg = "";
    },

    onChangeVehiclePool() {
      var self = this;
      self.vehicle_pool_err_msg = "";
    },

    loadGLAccount() {
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.loading = true;
      $.ajax({
        url: process.env.ROOT_API + "/gl-charge/" + segments[3],
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {
            if (data.content.cntrc_type != null && data.content.cntrc_type != "") {
              self.charge_type = {
                value: data.content.cntrc_type,
                text: self.ucString(data.content.cntrc_type)
              };
            }

            if (data.content.location_code != null && data.content.location_name != "") {
              self.location_id = {
                value: data.content.location_id,
                text: self.ucString(data.content.location_name) + " | " + data.content.location_code
              };
            }

            if (data.content.contract_type_name) {
              self.contract_type_id = {
                value: data.content.contract_type_id,
                text: self.ucString(data.content.contract_type_name) + "(" + data.content.contract_type_code + ")"
              };
            }

            if (data.content.charge_identifier) {
              self.charge_identifier_id = {
                value: data.content.charge_id,
                text: self.ucString(data.content.charge_identifier)
              };
            }


            if (data.content.vehicle_pool_description) {
              self.vehicle_pool_id = {
                value: data.content.vehicle_pool_id,
                text: self.ucString(data.content.vehicle_pool_description) + "(" + data.content.vehicle_pool_code + ")"
              };
            }

            if (data.content.gl_description) {
              self.gl_account_id = {
                value: data.content.gl_account_id,
                text: (data.content.gl_company ? self.ucString(data.content.gl_company) : '') + "|" + data.content.gl_code + "|" + data.content.gl_description
              };
            }

          }
        },
        error: function (jqXHR) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'gl-charge-details');
        }
      });
    },

    CreateGLCharge(flag) {
      var self = this;
      var error = false;

      self.location_error_msg = ""
      self.charge_type_error_msg = ""
      self.contract_type_error_msg = ""
      self.gl_account_error_msg = ""
      self.charge_identifier_err_msg = ""
      self.common_error_msg = ""

      if (!self.location_id || self.location_id == null || self.location_id == "") {
        self.location_error_msg = "Location Required.";
        error = true;
      }

      if (!self.charge_type || self.charge_type == null || self.charge_type == "") {
        self.charge_type_error_msg = "Charge Type Required.";
        error = true;
      }

      if (!self.contract_type_id || self.contract_type_id == null || self.contract_type_id == "") {
        self.contract_type_error_msg = "Contract Type Required.";
        error = true;
      }


      if (!self.gl_account_id || self.gl_account_id == null || self.gl_account_id == "") {
        self.gl_account_error_msg = "GL Account Required.";
        error = true;
        return;
      }

      if (!self.charge_identifier_id || self.charge_identifier_id == null || self.charge_identifier_id == "") {
        self.charge_identifier_err_msg = "Charge Identifier Required.";
        error = true;
        return;
      }

      if (!self.vehicle_pool_id || self.vehicle_pool_id == null || self.vehicle_pool_id == "") {
        self.vehicle_pool_err_msg = "Vehicle Pool Required.";
        error = true;
        return;
      }

      if (!error) {
        self.loading = true;
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
          $("#CreateGLChargeBtn").val("Updating ...");
          $("#CreateGLChargeBtn").prop("disabled", true);
          $("#cancelGLAccountBtn").prop("disabled", true);
        } else {
          if (flag == "Save and Continue") {
            $("#createAndContinueGLChargeBtn").val("Saving ...");
            $("#CreateGLChargeBtn").prop("disabled", true);
            $("#createAndContinueGLChargeBtn").prop("disabled", true);
            $("#cancelGLAccountBtn").prop("disabled", true);
          } else {
            $("#CreateGLChargeBtn").val("Saving ...");
            $("#CreateGLChargeBtn").prop("disabled", true);
            $("#createAndContinueGLChargeBtn").prop("disabled", true);
            $("#cancelGLAccountBtn").prop("disabled", true);
          }
        }

        var fields = $("#glChargeForm").serializeArray();
        if (!self.location_id || self.location_id.value == "") {
          fields.push({name: "location_id", value: ""});
        } else {
          fields.push({name: "location_id", value: self.location_id.value});
        }

        if (!self.charge_type || self.charge_type.value == "") {
          fields.push({name: "charge_type", value: ""});
        } else {
          fields.push({name: "charge_type", value: self.charge_type.value});
        }

        if (!self.contract_type_id || self.contract_type_id.value == "") {
          fields.push({name: "contract_type_id", value: ""});
        } else {
          fields.push({name: "contract_type_id", value: self.contract_type_id.value});
        }

        if (!self.gl_account_id || self.gl_account_id.value == "") {
          fields.push({name: "gl_account_id", value: ""});
        } else {
          fields.push({name: "gl_account_id", value: self.gl_account_id.value});
        }

        if (!self.charge_identifier_id || self.charge_identifier_id.value == "") {
          fields.push({name: "charge_identifier_id", value: ""});
        } else {
          fields.push({name: "charge_identifier_id", value: self.charge_identifier_id.value});
        }

        if (!self.vehicle_pool_id || self.vehicle_pool_id.value == "") {
          fields.push({name: "vehicle_pool_id", value: ""});
        } else {
          fields.push({name: "vehicle_pool_id", value: self.vehicle_pool_id.value});
        }
        fields.push({name: "id", value: segments[3]});

        $.ajax({
          url: process.env.ROOT_API + "/gl-charge/create",
          type: "POST",
          data: fields,
          headers: this.ajxHeaders,
          dataType: "json",
          success: function (data) {
            self.loading = false;
            if (segments[3]) {
              $("#CreateGLChargeBtn").val("Update");
              $("#CreateGLChargeBtn").prop("disabled", false);
              $("#cancelGLAccountBtn").prop("disabled", false);
            } else {
              if (flag == "Save and Continue") {
                $("#createAndContinueGLChargeBtn").val("Save and Continue");
                $("#CreateGLChargeBtn").prop("disabled", false);
                $("#createAndContinueGLChargeBtn").prop("disabled", false);
                $("#cancelGLAccountBtn").prop("disabled", false);
              } else {
                $("#CreateGLChargeBtn").val("Save");
                $("#CreateGLChargeBtn").prop("disabled", false);
                $("#createAndContinueGLChargeBtn").prop("disabled", false);
                $("#cancelGLAccountBtn").prop("disabled", false);
              }
            }

            if (data.status == "success") {
              if (flag == "Save and Continue") {
                $("#glChargeForm").trigger("reset");
                self.location_id = ""
                self.charge_type = ""
                self.contract_type_id = ""
                self.gl_account_id = ""
                self.charge_identifier_id = ""
                self.vehicle_pool_id = ""

                self.loadFieldData(['accountTypes', 'location', 'contractType', 'gl_account', 'contract_misc_charges', 'vehicle_pool']);
              } else {
                self.$router.push("/charge-account/list");
              }
            } else {
              if (data.content.length > 0) {
                var err = "";
                for (var i = 0; i < data.content.length; i++) {
                  err += data.content[i] + "<br>";
                  self.common_error_msg += data.content[i] + "\n";
                }
                setTimeout(function () {
                  self.common_error_msg = "";
                }, 10000);
              }
            }
          },

          error: function (jqXHR, exception) {
            self.loading = false;
            if (segments[3]) {
              $("#CreateGLChargeBtn").val("Update");
              $("#CreateGLChargeBtn").prop("disabled", false);
              $("#cancelGLAccountBtn").prop("disabled", false);
            } else {
              if (flag == "Save and Continue") {
                $("#glChargeForm").trigger("reset");
                $("#createAndContinueGLChargeBtn").val("Save and Continue");
                $("#CreateGLChargeBtn").prop("disabled", false);
                $("#createAndContinueGLChargeBtn").prop("disabled", false);
                $("#cancelGLAccountBtn").prop("disabled", false);

              } else {
                $("#CreateGLChargeBtn").val("Save");
                $("#CreateGLChargeBtn").prop("disabled", false);
                $("#createAndContinueGLChargeBtn").prop("disabled", false);
                $("#cancelGLAccountBtn").prop("disabled", false);
              }
            }
            self.generateStatusCodeMessage(jqXHR, false, 'gl-charge-details');
          }
        });
      } else {
        self.errorValidationFocus();
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/accounting/GLChargeCreate.vue